// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const SEND_CONTACT_FORM = 'SEND_CONTACT_FORM';
const CONTACT_FIELD_CHANGE = 'CONTACT_FIELD_CHANGE';
const CONTACT_ERRORS_CHANGE = 'CONTACT_ERRORS_CHANGE';
const SET_MESSAGE = 'SET_MESSAGE';
const RESET_FORM = 'RESET_FORM';

const CONTACT_REQUEST_PAGE_DATA = 'CONTACT_REQUEST_PAGE_DATA';
const CONTACT_REQUEST_PAGE_DATA_SUCCESS = 'CONTACT_REQUEST_PAGE_DATA_SUCCESS';

export {
  SEND_CONTACT_FORM,
  CONTACT_FIELD_CHANGE,
  CONTACT_ERRORS_CHANGE,
  SET_MESSAGE,
  RESET_FORM,

  CONTACT_REQUEST_PAGE_DATA,
  CONTACT_REQUEST_PAGE_DATA_SUCCESS
};
